// import React, { useEffect, useState } from 'react';
// import axios, { decryptData } from '../Axiosinstance';
// import { useParams } from 'react-router-dom';
// import { Modal } from 'react-bootstrap';
// import Loader from '../Loader';
// import CircularProgress from '@mui/material/CircularProgress';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import TablePagination from '@mui/material/TablePagination';
// import { baseURLdyte, Password, Username } from '../common'
// import Button from '@mui/material/Button';


// const Recoedings = () => {
//   const { batchId } = useParams();
//   // const { batchId } = useParams();
//   const batchId1 = decryptData(decodeURIComponent(batchId))
//   // const intakeId1 = decryptData(decodeURIComponent(intakeId))
//   const [batchDetails, setBatchDetails] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [matchingSessions, setMatchingSessions] = useState([]);
//   const [selectedSession, setSelectedSession] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [tableLoading, setTableLoading] = useState(true);

//   useEffect(() => {
//     const fetchBatchDetails = async () => {
//       try {
//         const response = await axios.get(`batch/${batchId1}`);
//         setBatchDetails(response.data);
//       } catch (error) {
//         console.error('Error fetching batch details:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchBatchDetails();
//   }, [batchId1]);

//   useEffect(() => {
//     const fetchSessions = async () => {
//       try {
//         const orgId = Username;
//         const apiKey = Password;
//         const authHeader = `Basic ${btoa(`${orgId}:${apiKey}`)}`;

//         const sessionsResponse = await axios.get(`${baseURLdyte}/recordings`, {
//           headers: {
//             Authorization: authHeader,
//           },
//         });

//         const sessions = sessionsResponse.data.data;

//         if (batchDetails && sessions) {
//           const url = batchDetails.onlineclasslink;
//           const match = url.match(/id=([a-f\d-]+)/i);

//           if (match && match[1]) {
//             const meetingId = match[1];

//             const matchingSessions = sessions.filter(
//               (session) => session.meeting_id === meetingId
//             );

//             setMatchingSessions(matchingSessions);
//             console.log(matchingSessions)
//           } else {
//             console.warn('Meeting ID not found in onlineclasslink');
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching sessions:', error);
//       } finally {
//         setTableLoading(false);
//       }
//     };

//     fetchSessions();
//   }, [batchDetails]);

//   // const formatDate = (dateString) => {
//   //   const options = {
//   //     year: 'numeric',
//   //     month: 'long',
//   //     day: 'numeric',
//   //     hour: 'numeric',
//   //     minute: 'numeric',
//   //     second: 'numeric',
//   //   };
//   //   return new Date(dateString).toLocaleDateString(undefined, options);
//   // };

//   function formatDate(dateInput) {
//     const date = new Date(dateInput);

//     if (isNaN(date.getTime())) {
//       throw new Error("Invalid date input");
//     }

//     const pad = (num) => String(num).padStart(2, '0');

//     const year = date.getFullYear();
//     const month = pad(date.getMonth() + 1);
//     const day = pad(date.getDate());
//     const hours = pad(date.getHours());
//     const minutes = pad(date.getMinutes());
//     const seconds = pad(date.getSeconds());

//     return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
//   }

//   const handleRowClick = (session) => {
//     setSelectedSession(session);
//     setShowModal(true);
//   };

//   const handleCloseModal = () => {
//     setSelectedSession(null);
//     setShowModal(false);
//   };

//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5); // Set the number of sessions per page

//   // Calculate the indexes for the current page
//   const indexOfLastSession = (page + 1) * rowsPerPage;
//   const indexOfFirstSession = indexOfLastSession - rowsPerPage;
//   const currentSessions = matchingSessions.slice(indexOfFirstSession, indexOfLastSession);

//   // Function to handle page change
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   // Function to handle rows per page change
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   return (
//     <div className='container-fluid' style={{ maxWidth: '1400px' }} >
//       <br />
//       {loading && <Loader />}
//       {!loading && (
//         <TableContainer>
//           <Table striped bordered hover responsive>
//             <TableHead>
//               <TableRow>
//                 <TableCell style={{ fontWeight: 'bold'}} >S.no</TableCell>
//                 <TableCell style={{ fontWeight: 'bold'}} >Meeting  Name</TableCell>
//                 <TableCell style={{ fontWeight: 'bold'}} >Recording Duration</TableCell>
//                 <TableCell style={{ fontWeight: 'bold'}} >Starting At</TableCell>
//                 <TableCell style={{ fontWeight: 'bold'}} >Ending At</TableCell>
//                 <TableCell style={{ fontWeight: 'bold'}} >Action</TableCell>
//               </TableRow> 
//             </TableHead>
//             <TableBody>
//               {tableLoading ? (
//                 <TableRow>
//                   <TableCell colSpan={6} style={{ textAlign: "center" }}>
//                     <CircularProgress />
//                   </TableCell>
//                 </TableRow>
//               ) : matchingSessions.length > 0 ? (
//                 matchingSessions.map((session, index) => (
//                   <TableRow key={session.id} onClick={() => handleRowClick(session)}>
//                     <TableCell>{index + 1}</TableCell>
//                     <TableCell>{session.meeting?.title || "N/A"}</TableCell>
//                     <TableCell>{session.recording_duration ? `${session.recording_duration} seconds` : "N/A"}</TableCell>
//                     <TableCell>{session.started_time ? formatDate(session.started_time) : "N/A"}</TableCell>
//                     <TableCell>{session.stopped_time ? formatDate(session.stopped_time) : "N/A"}</TableCell>
//                     <TableCell>
//                       <Button variant='contained' color='primary' >View Video</Button>
//                     </TableCell>
//                   </TableRow>
//                 ))
//               ) : (
//                 <TableRow>
//                   <TableCell colSpan={6} style={{ textAlign: "center", color: "gray" }}>
//                     No Data Available
//                   </TableCell>
//                 </TableRow>
//               )}
//             </TableBody>


//           </Table>

//           {/* Modal */}
//           <Modal show={showModal} onHide={handleCloseModal} size="lg">
//             <Modal.Header closeButton>
//               <Modal.Title>Recording Details</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//               {selectedSession && (
//                 <div>
//                   <h5 className="mb-3">Meeting Name: {selectedSession.meeting.title}</h5>
//                   <p>Recording Duration: {selectedSession.recording_duration} seconds</p>
//                   <p>Started At: {formatDate(selectedSession.started_time)}</p>
//                   <p>Ended At: {formatDate(selectedSession.stopped_time)}</p>

//                   <div className="embed-responsive embed-responsive-16by9 mb-3">
//                     <video className="embed-responsive-item" controls width="100%">
//                       <source src={selectedSession.download_url} type="video/mp4" />
//                       Your browser does not support the video tag.
//                     </video>
//                   </div>

//                   <p>
//                     <a
//                       href={selectedSession.download_url}
//                       download={selectedSession.output_file_name}
//                       className="btn btn-primary"
//                       style={{ backgroundColor: '#007bff', borderColor: '#007bff', color: "white" }}
//                     >
//                       Download
//                     </a>
//                   </p>
//                 </div>
//               )}
//             </Modal.Body>
//           </Modal>

//           <TablePagination
//             component="div"
//             count={matchingSessions.length}
//             page={page}
//             onPageChange={handleChangePage}
//             rowsPerPage={rowsPerPage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//           />
//         </TableContainer>
//       )}
//     </div>
//   );

// };

// export default Recoedings;


import React, { useEffect, useState } from 'react';
import axios, { decryptData } from '../Axiosinstance';
import { useParams } from 'react-router-dom';
import Loader from '../Loader';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { baseURLdyte, dyteRestHeader } from '../common';

const Recordings = () => {
  const { batchId } = useParams();
  const batchId1 = decryptData(decodeURIComponent(batchId));

  const [batchDetails, setBatchDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [matchingSessions, setMatchingSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // ── Fetch batch details ─────────────────────────────────────────────────────
  useEffect(() => {
    const fetchBatchDetails = async () => {
      try {
        const response = await axios.get(`batch/${batchId1}`);
        setBatchDetails(response.data);
      } catch (error) {
        console.error('Error fetching batch details:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchBatchDetails();
  }, [batchId1]);

  // ── Fetch recordings ────────────────────────────────────────────────────────
  useEffect(() => {
    if (!batchDetails) return;

    const fetchRecordings = async () => {
      try {
        // ✅ Use dyteRestHeader from common.js
        const response = await axios.get(`${baseURLdyte}/recordings`, {
          headers: {
            Authorization: dyteRestHeader,
          },
        });

        const recordings = response.data?.data;

        if (!recordings) {
          console.warn('No recordings data in response');
          setMatchingSessions([]);
          return;
        }

        // Extract meeting ID from batch online class link
        const url = batchDetails.onlineclasslink;
        const match = url?.match(/id=([a-f\d-]+)/i);

        if (match && match[1]) {
          const meetingId = match[1];
          const filtered = recordings.filter(
            (recording) => recording.meeting_id === meetingId
          );
          setMatchingSessions(filtered);
          console.log('Matching recordings:', filtered);
        } else {
          console.warn('Meeting ID not found in onlineclasslink');
          setMatchingSessions([]);
        }
      } catch (error) {
        console.error('Error fetching recordings:', error);
        setMatchingSessions([]);
      } finally {
        setTableLoading(false);
      }
    };

    fetchRecordings();
  }, [batchDetails]);

  // ── Helpers ─────────────────────────────────────────────────────────────────
  const formatDate = (dateInput) => {
    if (!dateInput) return 'N/A';
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return 'Invalid date';

    const pad = (num) => String(num).padStart(2, '0');
    return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  };

  const formatDuration = (seconds) => {
    if (!seconds) return 'N/A';
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return mins > 0 ? `${mins} min ${secs} sec` : `${secs} sec`;
  };

  const handleViewVideo = (session) => {
    setSelectedSession(session);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedSession(null);
    setShowModal(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // ✅ Paginated slice — was calculated but never used before
  const indexOfFirstSession = page * rowsPerPage;
  const indexOfLastSession = indexOfFirstSession + rowsPerPage;
  const currentSessions = matchingSessions.slice(indexOfFirstSession, indexOfLastSession);

  // ── Render ──────────────────────────────────────────────────────────────────
  if (loading) return <Loader />;

  return (
    <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 16px' }}>
      <br />
      <Paper elevation={2}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                <TableCell style={{ fontWeight: 'bold' }}>S.No</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Meeting Name</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Duration</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Started At</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Ended At</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {tableLoading ? (
                <TableRow>
                  <TableCell colSpan={6} style={{ textAlign: 'center', padding: '40px' }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : currentSessions.length > 0 ? (
                // ✅ FIXED — uses paginated currentSessions not full matchingSessions
                currentSessions.map((session, index) => (
                  <TableRow
                    key={session.id}
                    hover
                    style={{ cursor: 'pointer' }}
                  >
                    <TableCell>{indexOfFirstSession + index + 1}</TableCell>
                    <TableCell>{session.meeting?.title || 'N/A'}</TableCell>
                    <TableCell>{formatDuration(session.recording_duration)}</TableCell>
                    <TableCell>{formatDate(session.started_time)}</TableCell>
                    <TableCell>{formatDate(session.stopped_time)}</TableCell>
                    <TableCell>
                      {/* ✅ FIXED — onClick works, stopPropagation prevents double trigger */}
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleViewVideo(session);
                        }}
                      >
                        View Video
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={6}
                    style={{ textAlign: 'center', color: 'gray', padding: '40px' }}
                  >
                    No Recordings Available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* ✅ Pagination — count uses full list length not current page slice */}
        <TablePagination
          component="div"
          count={matchingSessions.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>

      {/* ✅ Recording Detail Modal — fully Material UI, no react-bootstrap */}
      <Dialog
        open={showModal}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Recording Details
        </DialogTitle>

        <DialogContent dividers>
          {selectedSession && (
            <div>
              <Typography variant="h6" gutterBottom>
                {selectedSession.meeting?.title || 'N/A'}
              </Typography>

              <Typography variant="body1" gutterBottom>
                <strong>Duration:</strong> {formatDuration(selectedSession.recording_duration)}
              </Typography>

              <Typography variant="body1" gutterBottom>
                <strong>Started At:</strong> {formatDate(selectedSession.started_time)}
              </Typography>

              <Typography variant="body1" gutterBottom>
                <strong>Ended At:</strong> {formatDate(selectedSession.stopped_time)}
              </Typography>

              <div style={{ marginTop: '16px', marginBottom: '16px' }}>
                {selectedSession.download_url ? (
                  <video
                    controls
                    width="100%"
                    style={{ borderRadius: '8px' }}
                  >
                    <source src={selectedSession.download_url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <Typography color="textSecondary">
                    No video available for this recording.
                  </Typography>
                )}
              </div>
            </div>
          )}
        </DialogContent>

        <DialogActions>
          {selectedSession && selectedSession.download_url && (
            <Button
              variant="contained"
              color="primary"
              href={selectedSession.download_url}
              download={selectedSession.output_file_name || 'recording.mp4'}
              target="_blank"
              rel="noopener noreferrer"
            >
              Download
            </Button>
          )}
          <Button
            variant="outlined"
            onClick={handleCloseModal}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Recordings;